import { TabletCategory, ContentType } from '@amzn/fire-tv-campaign-automation-service';

/**
 * Derives ContentType from TabletCategory
 */
export function deriveContentTypeFromCategory(category: TabletCategory): ContentType {
  switch (category) {
    case TabletCategory.KINDLE_BOOKS:
    case TabletCategory.KINDLE_UNLIMITED:
      return ContentType.BOOKS;
    case TabletCategory.AUDIBLE_BOOKS:
    case TabletCategory.AUDIBLE_SUBS:
      return ContentType.AUDIOBOOK;
    case TabletCategory.MUSIC:
      return ContentType.MUSIC;
    case TabletCategory.GAMING:
      return ContentType.GAMES;
    case TabletCategory.PRIME_VIDEO:
    case TabletCategory.VIDEO_KIDS:
      return ContentType.VIDEO;
    case TabletCategory.APPS:
    case TabletCategory.KIDS_PLUS:
      return ContentType.APPS;
    default:
      return ContentType.VIDEO; // Default fallback
  }
}
